<template>
  <div>
    <div
      class="search-bar-margin-bottom-cla"
      style="display: flex;justify-content: space-between;"
    >
      <el-form ref="searchForm" :model="searchParams" inline label-width="80">
        <el-form-item prop="dstName" :label="$t('quartzJob.jobId')">
          <el-input
            type="text"
            v-model.trim="searchParams.jobId"
            :placeholder="this.$t('quartzJob.jobIdRequire')"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="query()">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>
      </el-form>

      <el-button
        style="margin-right:20px"
        type="primary"
        icon="el-icon-search"
        @click="addDia()"
        >{{ $t('common.add') }}</el-button
      >
    </div>

    <div class="black_panel_cla">
      <zk-table :columns="columns" :data="data"> </zk-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="pageSizeChange(arguments[0], pageList)"
          @current-change="curPageChange(arguments[0], pageList)"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="diaType === 'add' ?this.$t('common.add') :this.$t('common.edit')"
      :visible.sync="showDialog"
      width="45%"
    >
      <el-form
        ref="formValidate"
        :model="params"
        label-position="right"
        label-width="180px"
        :rules="rules"
      >
        <el-form-item prop="beanName" :label="$t('quartzJob.beanName')">
          <el-input
            type="text"
            v-model="params.beanName"
            :placeholder="$t('quartzJob.beanName')"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="methodName" :label="$t('quartzJob.methodName')">
          <el-input
            type="text"
            v-model="params.methodName"
            :placeholder="$t('quartzJob.methodName')"
          ></el-input>
        </el-form-item>

        <el-form-item prop="params" :label="$t('quartzJob.params')">
          <el-input
            type="text"
            v-model="params.params"
            :placeholder="$t('quartzJob.params')"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          prop="cronExpression"
          :label="$t('quartzJob.cronExpression')"
        >
          <el-input
            type="text"
            v-model="params.cronExpression"
            :placeholder="$t('quartzJob.cronExpression')"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="status" :label="$t('quartzJob.status')">
          <!-- <el-input
            type="text"
            v-model="params.status"
            :placeholder="$t('quartzJob.status')"
          >    </el-input> -->
          <el-radio-group v-model="params.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="remark" :label="$t('quartzJob.remark')">
          <el-input
            type="text"
            v-model="params.remark"
            :placeholder="$t('quartzJob.remark')"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="logOn" :label="$t('quartzJob.logOn')">
          <el-radio-group v-model="params.logOn">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="extraId" :label="$t('quartzJob.extraId')">
          <el-input
            type="text"
            v-model="params.extraId"
            :placeholder="$t('quartzJob.extraId')"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitFrom">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as quartzJobApi from '@/services/quartzJobApi.js'
import { Loading } from 'element-ui'
export default {
  data() {
    let _self = this
    let columns = [
      {
        prop: 'beanName',
        label: this.$t('quartzJob.beanName')
      },
      //   {
      //     prop: 'companyCode',
      //     label: this.$t('quartzJob.companyCode')
      //   },
      //   {
      //     prop: 'companyId',
      //     label: this.$t('quartzJob.companyId')
      //   },
      {
        prop: 'createTime',
        label: this.$t('quartzJob.createTime')
      },
      {
        prop: 'cronExpression',
        label: this.$t('quartzJob.cronExpression')
      },
      {
        prop: 'extraId',
        label: this.$t('quartzJob.extraId')
      },
      {
        prop: 'jobId',
        label: this.$t('quartzJob.jobId')
      },
      {
        prop: 'logOn',
        label: this.$t('quartzJob.logOn')
      },
      {
        prop: 'methodName',
        label: this.$t('quartzJob.methodName')
      },
      {
        prop: 'params',
        label: this.$t('quartzJob.params')
      },
      {
        prop: 'remark',
        label: this.$t('quartzJob.remark')
      },
      {
        prop: 'status',
        label: this.$t('quartzJob.status'),
        render: (h, params) => {
          let a = null
          if (params.row.status === 0) {
            a = h(
              'span',
              {
                style: {
                  color: '#19cd0f'
                }
              },
              [this.$t('common.enableStatus')]
            )
          } else {
            a = h(
              'span',
              {
                style: {
                  color: 'red'
                }
              },
              [this.$t('common.disabled')]
            )
          }
          return a
        }
      },
      {
        label: this.$t('common.operation'),
        minWidth: '200px',
        render: (h, params) => {
          let events = []
          if (params.row.status === 0) {
            events = ['quartzDelete', 'runJob', 'pauseJob', 'updateJob']
          } else {
            events = ['quartzDelete', 'runJob', 'resumeJob', 'updateJob']
          }
          return h('ZkButtonGroup', {
            props: {
              onlyShowText: true,
              groupName: 'quartzBtnGroup',
              params: params.row,
              isGroup: true,
              event: events
            },
            key: params.row.jobId + params.row.status,
            on: {
              updateJob(row) {
                _self.editDia(row)
              },
              quartzDelete(row) {
                _self.delete(row)
              },
              runJob(row) {
                // 运行
                _self.runJob(row)
              },
              resumeJob(row) {
                // 恢复
                _self.resumeJob(row)
              },
              pauseJob(row) {
                // 暂停
                _self.pauseJob(row)
              }
            }
          })
        }
      }
    ]
    let rules = {
      beanName: [
        { required: true, message: this.$t('common.notEmpyt'), trigger: 'blur' }
      ],
      methodName: [
        { required: true, message: this.$t('common.notEmpyt'), trigger: 'blur' }
      ],
      cronExpression: [
        { required: true, message: this.$t('common.notEmpyt'), trigger: 'blur' }
      ]
    }
    return {
      searchParams: {
        jobId: ''
      },
      data: [],
      rules,
      showDialog: false,
      diaType: 'add',
      params: {
        beanName: '',
        methodName: '',
        params: null,
        cronExpression: '',
        status: 0,
        remark: '',
        logOn: true,
        extraId: ''
      },
      columns,
      loadingInstance: null
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    onCancel() {
      this.showDialog = false
      Object.keys(this.params).forEach(key => {
        this.params[key] = ''
      })
    },
    addDia() {
      Object.keys(this.params).forEach(key => {
        if (key === 'status') {
          this.params[key] = 0
        } else if (key === 'logOn') {
          this.params[key] = true
        } else {
          this.params[key] = ''
        }
      })
      this.showDialog = true
      this.diaType = 'add'
    },
    editDia(row) {
      this.showDialog = true
      this.diaType = 'edit'
      Object.keys(row).forEach(key => {
        this.params[key] = row[key]
      })
    },
    submitFrom() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let promise = null
          if (this.diaType === 'add') {
            this.callback(this.submitAdd())
          } else {
            this.callback(this.submitEdit())
          }
          if (promise !== null) {
          }
        }
      })
    },
    callback(promise) {
      if (promise != null) {
        promise
          .then(data => {
            if (data.code === '00000000') {
              this.showDialog = false
              this.successMessage()
              this.closeLoading()
              this.pageList()
            } else {
              this.$message.error(data.message)
            }
          })
          .catch(e => this.errorMessage())
      }
    },
    submitAdd() {
      this.showLoading()
      delete this.params.jobId
      return quartzJobApi.addJob(this.params)
    },
    submitEdit() {
      this.showLoading()
      return quartzJobApi.updateJob(this.params)
    },
    runJob(row) {
      // 运行
      this.showLoading()
      this.callback(
        quartzJobApi.runJob({
          jobId: row.jobId
        })
      )
    },
    resumeJob(row) {
      // 恢复
      this.showLoading()
      this.callback(
        quartzJobApi.resumeJob({
          jobId: row.jobId
        })
      )
    },
    pauseJob(row) {
      // 暂停
      this.showLoading()
      this.callback(
        quartzJobApi.pauseJob({
          jobId: row.jobId
        })
      )
    },
    delete(row) {
      this.$confirm(
        this.$t('common.deleteTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.delete'),
          type: 'warning'
        }
      ).then(() => {
        this.callback(
          quartzJobApi.deleteJob({
            jobId: row.jobId
          })
        )
      })
    },

    showLoading() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('common.timeSnyc'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeLoading() {
      if (this.loadingInstance !== null) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    },

    query() {
      this.pager.curPage = 1
      this.pageList()
    },
    pageList() {
      let params = {
        pager: this.pager,
        params: this.params
      }
      quartzJobApi.pageList(params).then(data => {
        this.data = data.payload.results
        this.pager.curPage = data.payload.curPage
        this.pager.total = data.payload.totalRecords
        this.pager.pageSize = data.payload.pageSize
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
<!--
commandBackupTask1

configureTasks1

0 0 0 1/1 * ?

-->



// WEBPACK FOOTER //
// src/modules/sysOptions/quartzJob.vue